import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Reset scroll on navigation so new pages start at the top.
    // Use rAF to run after the new route has painted.
    const scroll = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch {
        window.scrollTo(0, 0);
      }

      const el = document.scrollingElement || document.documentElement;
      if (el) el.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };

    const id1 = window.requestAnimationFrame(() => {
      scroll();
      window.requestAnimationFrame(scroll);
    });

    return () => window.cancelAnimationFrame(id1);
  }, [location.key]);

  return null;
}
